import Modal from '@components/v2/ui/Modal/Modal';
import type { ModalFooterConfig } from '@components/v2/ui/Modal/modal.types';
import { ReactElement } from 'react';
import LangEnum from '../../../../lang/LangEnum';

type ForceUpdateBaseModalProps = {
  isOpen: boolean;
  title: LangEnum;
  onAccept: () => void;
  onDeny: () => void;
  onClose: () => void;
  acceptLabel?: LangEnum;
  denyLabel?: LangEnum;
  content?: ReactElement;
  disablePrimaryAction?: boolean;
};

const ForceUpdateBaseModal = ({
  title,
  isOpen,
  onDeny,
  onClose,
  content,
  onAccept,
  denyLabel,
  acceptLabel,
  disablePrimaryAction = false,
}: ForceUpdateBaseModalProps) => {
  const buildFooter = (): ModalFooterConfig | undefined => {
    const denyAction = denyLabel ? { label: denyLabel, onClick: onDeny } : undefined;

    if (acceptLabel) {
      return {
        primaryAction: {
          label: acceptLabel,
          isDisabled: disablePrimaryAction,
          onClick: onAccept,
        },
        secondaryAction: denyAction,
      };
    }

    return denyAction ? { primaryAction: denyAction } : undefined;
  };

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title }}
      onClose={onClose}
      footer={buildFooter()}
    >
      {content}
    </Modal>
  );
};

export default ForceUpdateBaseModal;
